import { render, staticRenderFns } from "./ReportImageDamageOptional.vue?vue&type=template&id=288583d7&"
import script from "./ReportImageDamageOptional.vue?vue&type=script&lang=ts&"
export * from "./ReportImageDamageOptional.vue?vue&type=script&lang=ts&"
import style0 from "./ReportImageDamageOptional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VTextarea})
